export default [
  {codigo: 'AGUARDANDO_ANALISE', nome: 'Aguardando Análise'},
  {codigo: 'ARQUIVADO', nome: 'Arquivado'},
  {codigo: 'FINALIZADO', nome: 'Finalizado'},
  {codigo: 'CANCELADO', nome: 'Cancelado'}
]



// WEBPACK FOOTER //
// ./src/constants/statusProcessosCentral.js